import React from 'react';
import _ from 'lodash';

import Joi from 'joi';
import PropTypes from 'prop-types';

import AutGISystemSettingsForm from './autGISystemSettingsForm';
import AUTGIAutEquipmentForm from './autGIAutEquipmentForm';
import AUTGIObjectInformationForm from './autGIObjectInformationForm';
import EquipmentInformationForm from './autGIMaxwellEquipmentForm';

import Conditional from '../../../common/conditional';
import Form from '../../../common/form';

import { GIAutEquipmentData, GIMaxwellEquipmentData, GIObjectInformationData, GISystemSettingsData } from '../../../../utils/models';
import { getGeneralInfoDummyData } from '../../../../utils/data';

import toastService from '../../../../services/toastService';

class AUTGeneralInformationForm extends Form {
	state = {
		data: _.omit(getGeneralInfoDummyData(), ['objectInformation']),
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		systemSettings: Joi.any().required().label('System Settings'),
		objectInformation: Joi.any().optional().label('AUT Object Information'),
		autEquipmentInformation: Joi.any().optional().label('AUT Equipment Information'),
		maxwellEquipmentInformation: Joi.any().optional().label('Maxwell Equipment Information'),
	};

	static defaultProps = {
		enableMaxwellData: true,
		enableAutData: true,
		enableObjectInformation: false,
		enableSystemSettings: true,
	};

	static propTypes = {
		initialData: PropTypes.object,
		enableMaxwellData: PropTypes.bool,
		enableSystemSettings: PropTypes.bool,
		enableAutData: PropTypes.bool,
		enableObjectInformation: PropTypes.bool,
		onProceed: PropTypes.func,
	};

	componentDidMount() {
		if (this.props.initialData) {
			this.setState({ data: this.props.initialData });
		}
	}

	doSubmit = (): void => {
		this.props.onProceed(this.state.data);
		toastService.success('General Information Saved Successfully!');
	};

	handleSystemSettingSave = (systemSettings: GISystemSettingsData) => {
		this.setState({ data: { ...this.state.data, systemSettings } }, () => {
			this.props.onProceed(this.state.data)
		});
	};

	handleAutEquipmentSave = (autEquipment: GIAutEquipmentData) => {
		this.setState({ data: { ...this.state.data, autEquipmentInformation: autEquipment } }, () => {
			this.props.onProceed(this.state.data)
		});
	};
	
	handleObjectInformationSave = (objectInformation: GIObjectInformationData) => {
		this.setState({ data: { ...this.state.data, objectInformation } }, () => {
			this.props.onProceed(this.state.data)
		});
	};

	handleMaxwellEquipmentSave = (maxwellEquipment: GIMaxwellEquipmentData) => {
		this.setState({ data: { ...this.state.data, maxwellEquipmentInformation: maxwellEquipment } }, () => {
			this.props.onProceed(this.state.data)
		});
	};

	render() {
		return (
			<React.Fragment>
				<div className="divider my-4"></div>

				<Conditional isVisible={this.props.enableSystemSettings}>
					<div className="p-4 rounded bg-light bordered mb-4">
						<AutGISystemSettingsForm 
							initialData={this.props.initialData ? this.props.initialData.systemSettings : undefined} 
							onProceed={this.handleSystemSettingSave} 
						/>
					</div>
				</Conditional>

				<div className="divider my-4"></div>
				
				<Conditional isVisible={this.props.enableObjectInformation}>
					<div className="p-4 rounded bg-light bordered mb-4">
						<AUTGIObjectInformationForm 
							initialData={this.props.initialData ? this.props.initialData.objectInformation : undefined} 
							onProceed={this.handleObjectInformationSave} 
						/>
					</div>

					<div className="divider my-4"></div>
				</Conditional>

				<Conditional isVisible={this.props.enableAutData}>
					<div className="p-4 rounded bg-light bordered mb-4">
						<AUTGIAutEquipmentForm 
							initialData={this.props.initialData ? this.props.initialData.autEquipmentInformation : undefined}
							onProceed={this.handleAutEquipmentSave} />
					</div>

					<div className="divider my-4"></div>
				</Conditional>

				<Conditional isVisible={this.props.enableMaxwellData}>
					<div className="p-4 rounded bg-light bordered mb-4">
						<EquipmentInformationForm 
							initialData={this.props.initialData ? this.props.initialData.maxwellEquipmentInformation : undefined} 
							onProceed={this.handleMaxwellEquipmentSave} 
						/>
					</div>

					<div className="divider my-4"></div>
				</Conditional>

				<Conditional isVisible={false}>
					<form autoComplete="off" onSubmit={this.handleSubmit}>
						<div className="justify-content-end d-flex">
							{this.renderButton('Save General Information')}
						</div>
					</form>
				</Conditional>
			</React.Fragment>
		);
	}
}

export default AUTGeneralInformationForm;
